export { KTPinInput } from './pin-input';
export type {
	KTPinInputConfigInterface,
	KTPinInputEventPayloadInterface,
	KTPinInputInterface,
} from './types';
